import React, { useState } from "react";
import "./faq.scss";
import { ArrowRight } from "../../../icons";

export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: "W jakim rejonie świadczycie usługi remontowo-wykończeniowe?",
    answer:
      "Nasza siedziba to Dębica, a usługi świadczymy w promieniu do 100 km – obsługujemy m.in. Rzeszów, Tarnów, Mielec, Ropczyce, Pilzno, Sędziszów Małopolski, Jasło oraz całe województwo podkarpackie i małopolskie.",
  },
  {
    question: "Czy wycena i konsultacja na miejscu inwestycji są bezpłatne?",
    answer:
      "Tak, wstępna rozmowa, dojazd na oględziny lokalu/domu oraz przygotowanie szczegółowej, przejrzystej wyceny są całkowicie bezpłatne i nie zobowiązują do podpisania umowy.",
  },
  {
    question:
      "Czy wykonujecie kompleksowe wykończenia mieszkań, czy także mniejsze etapy?",
    answer:
      "Realizujemy zarówno kompleksowe wykończenia wnętrz od stanu deweloperskiego pod klucz, jak i poszczególne pakiety prac: zabudowy gipsowo-kartonowe, nowoczesne sufity podwieszane z oświetleniem LED, malowanie natryskowe czy montaż paneli podłogowych.",
  },
  {
    question: "Czy pomagacie w doborze i transporcie materiałów budowlanych?",
    answer:
      "Tak, chętnie służymy fachowym doradztwem w doborze odpowiednich gruntów, gładzi, farb zmywalnych oraz paneli. Współpracujemy ze sprawdzonymi dostawcami i hurtowniami budowlanymi, pomagając w wyliczeniach i logistyce.",
  },
  {
    question: "Czy na wykonane usługi wykończeniowe udzielana jest gwarancja?",
    answer:
      "Oczywiście. Na wszystkie wykonane przez nas prace remontowo-wykończeniowe udzielamy gwarancji. Dbamy o najwyższe standardy techniczne, estetykę oraz porządek na każdym etapie realizacji.",
  },
];

const Faq: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleItem = (idx: number) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  };

  return (
    <section className="faq">
      <div className="faq__container">
        <header className="faq__header">
          <div className="faq__header-top">
            <span className="faq__header-line" />
            <h2 className="faq__title">Najczęściej Zadawane Pytania</h2>
            <span className="faq__header-line" />
          </div>
          <p className="faq__description">
            Masz pytania dotyczące remontu lub wykończenia wnętrza? Sprawdź
            odpowiedzi na najczęstsze kwestie techniczne i organizacyjne.
          </p>
        </header>

        <div className="faq__list">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={index} className="faq__item">
                <button
                  className="faq__question-btn"
                  onClick={() => toggleItem(index)}
                  aria-expanded={isOpen}
                >
                  <span>{item.question}</span>
                  <span
                    className={`faq__icon ${isOpen ? "faq__icon--open" : ""}`}
                  >
                    <ArrowRight />
                  </span>
                </button>
                {isOpen && <div className="faq__answer">{item.answer}</div>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Faq;
